import { Tag } from "Components";
import { PropertyData } from "../CampaignReport.type";
import { GET_COLOR_BY_SCORE } from "../CampaignReport.constant";

const PropertyListItem = ({ propertyData }: { propertyData: PropertyData }) => {
    const { color: resultColor, bg: resultBg } = GET_COLOR_BY_SCORE(propertyData.pass_rate || 0);

    return <div className='list-item property-item'>
        <div className='row'>
            <span className='title'>{propertyData.group_name}</span>
            <Tag className='status-tag' style={{ color: resultColor, background: resultBg }}>
                {`${propertyData.pass_rate}%`}
            </Tag>
        </div>
        <div className='row'>
            <span className='description'><strong>Open: </strong>{propertyData.opened_rate}</span>
            <span className='description'><strong>Click: </strong>{propertyData.clicked_rate}</span>
        </div>
        <div className='row'>
            <span className='description'><strong>Sent: </strong>{propertyData.email_sent_count}</span>
            <span className='description'><strong>Submit: </strong>{propertyData.submission_rate}</span>
        </div>
        <div className='row'>
            <span className='description'><strong>Clicked: </strong>{propertyData.clicked_link_count}</span>
            <span className='description'><strong>Submitted: </strong>{propertyData.submitted_data_count}</span>
        </div>
        <div className='row'>
            <span className='description'><strong>Opened: </strong>{propertyData.email_opened_count}</span>
            <span className='description'><strong>Total Users: </strong>{propertyData.users_count}</span>
        </div>
    </div>
}

export default PropertyListItem;